module.exports = __webpack_public_path__ + "img/incein-l-circle-4.8220d310.svg";